import React from 'react'
import { StatusTone } from '../../redux-toolkits/shared/shared.type'
export const Status: React.FC<{
  type: StatusTone
  text: string
  className?: string
}> = ({ type, text, className }) => {
  return (
    <div
      className={`
      lowercase
      ${type === 'success' && 'bg-success-light text-success'}
      ${type === 'fail' && 'bg-danger-light text-danger'}
      ${type === 'warn' && 'bg-warn-light text-warn'}
      ${type === 'blue' && 'bg-pill-blue-bg text-pill-blue'}
      px-[10px] py-[1px]
      border border-transparent
      rounded-full
      w-fit
      capitalize
      font-normal
      ${className}
        `}
    >
      {text}
    </div>
  )
}
